import * as React from 'react'
import styled from 'styled-components'
import { Color, Size } from '../../../constants/app.constant'

interface Props {
  onChange?: (e: React.SyntheticEvent) => void
  name?: string
  placeholder?: string
  type?: string
  value?: string | number
  maxLength?: number
  invalidMessage?: string
  className?: string
}

const InputTextArea: React.SFC<Props> = (props: Props) => (
  <div>
    <StyledInputTextArea {...props} isInvalid={!!props.invalidMessage} />
    <InvalidMessage>{props.invalidMessage}</InvalidMessage>
  </div>
)
const InvalidMessage = styled.p`
  color: ${Color.STATUS_COLOR.STATUS_1};
  margin-top: 10px;
  font-size: ${Size.FONT.SMALL}px;
`

const StyledInputTextArea = styled.textarea<{ isInvalid: boolean }>`
  border: 1;
  border-bottom: 1px solid ${Color.PALETTE_COLOR.VERY_LIGHT_GRAY};
  padding: 6px 0;
  font-size: ${Size.FONT.MIDDLE}px;
  width: 100%;
  height: 150px;

  &::placeholder {
    color: ${Color.PALETTE_COLOR.LIGHT_GRAY};
  }

  &:focus {
    outline-style: none;
    border-bottom: 1px solid ${Color.STATUS_COLOR.STATUS_3};
  }

  ${({ isInvalid }) =>
    isInvalid &&
    `border-bottom: 1px solid ${Color.STATUS_COLOR.STATUS_1};
  `};
`
export default InputTextArea



// WEBPACK FOOTER //
// ./src/components/atoms/input-text/input-textarea.tsx